<template>
  <div class="shortcut-desc">
    <div>* 鼠标单击图片选中</div>
    <div>* Win全选：Ctrl+A</div>
    <div>* Mac全选：Option[⌥]+A</div>
    <div>* Win多选：Ctrl+左键单击</div>
    <div>* Mac多选：Option[⌥]+左键</div>
    <div>* 按Shift+左键单击进行连选</div>
  </div>
</template>

<script>
export default {
  name: "ShortcutDesc"
}
</script>

<style lang="less" scoped>
.shortcut-desc {
  line-height: 20px;
}
</style>
